import type { FirestoreContainer } from './FirestoreContainer.js';

import { createContainer } from '@elara/core/di';

import { createClientHotelMediaModel } from '#models/HotelMediaModel.js';
import { createClientHotelModel } from '#models/HotelModel.js';

/**
 * Client-side Hotels Container for dependency injection.
 *
 * This container manages the creation and registration of the client-side `Hotel` model
 * and the `HotelMedia` model (full photo galleries in the media subcollection).
 * It ensures the models are properly initialized with their dependencies, such as the
 * Firestore instance.
 */
export function createHotelsContainer(firestore: FirestoreContainer) {
  const $hotels = createContainer('hotels')
    .providedLazy('ClientHotel', () => createClientHotelModel(firestore))
    .providedLazy('ClientHotelMedia', () => createClientHotelMediaModel(firestore));
  return $hotels;
}

export type $HotelsContainer = ReturnType<typeof createHotelsContainer>;
export type HotelsContainer = $HotelsContainer['use'];

